import { object, ObjectSchema, string } from "yup";
import { UsernameType } from "../types";
import { emailRequired } from "@covertree/utils";

export interface ForgotPasswordFormData {
  username: string;
}

export const defaultValues: ForgotPasswordFormData = {
  username: "",
};

export const createValidationSchema = (
  usernameType: UsernameType
): ObjectSchema<ForgotPasswordFormData> =>
  object({
    username:
      usernameType === "email"
        ? emailRequired()
        : string().required("Phone number is required"),
  });
